import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CapacityAlert, INITIAL_CAPACITY } from "userful-chronos-app-common-js/dist/models/notifications/notifications";

const initialState: {
    data: CapacityAlert;
} = {
    data: INITIAL_CAPACITY,
};

export const capacitySlice = createSlice({
    name: "capacitySlice",
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<CapacityAlert>) => {
            state.data = { ...action.payload };
        },
    },
});

export const capacityActions = capacitySlice.actions;

export default capacitySlice.reducer;
